import dayjs from "dayjs";

export const percentageFormatter = {
  type: "number",
  valueFormatter: (value) =>
    value != undefined
      ? `${value.toLocaleString(undefined, { minimumFractionDigits: 2 })} %`
      : "",
};

export const dateFormatter = {
  valueFormatter: (value) => dayjs(value).format("DD/MM/YY"),
};

export const currencyFormatterMXN = {
  // type: "number",
  valueFormatter: (value) =>
    value != undefined ? formatCurrency(value) : value,
};

export const currencyFormatterUSD = {
  valueFormatter: (value) =>
    value != undefined ? formatCurrency(value, "USD") : value,
};

export const formatCurrency = (value, currency = "MXN") => {
  if (!value || value === 0) return "0.00";
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: currency,
  }).format(value);
};

export const formatPercentage = (value) => {
  if (!value) return "";
  return `${value.toLocaleString(undefined, { minimumFractionDigits: 2 })} %`;
};

export const agGridDateFormatter = (params) => {
  if (!params.value) return "";
  const date = dayjs(params.value);
  return date.isValid() ? date.format("DD/MM/YYYY") : "-";
};
